<template>
  <div class="tela-cargas">
    <Executar
        :rotina="currentRotina"
        :close="closeExecutar"
        :executarRotina="executarRotina"
    ></Executar>
    <InfoRotina
      :rotina="currentRotina"
      :close="closeInfo"
      :descricao="descSingular"
      :loadRotinas="loadRotinas"
      :syncRotina="openExecutar"
    />
    <Loading :isActive="loading"></Loading>

    <!-- Barra de ferramentas -->
    <div class="toolbar">
      <span class="toolbar__search">
        <fa-icon icon="search" class="toolbar__search-icon" />
        <input
            type="text"
            v-model="termo"
            placeholder="Filtrar rotinas por título..."
            v-on:input="debounceLoadRotinas()">
      </span>
      <div class="toolbar__right">
        <button class="button button-primary" v-on:click="loadRotinas(currentPage)">
          <fa-icon icon="sync" /> Atualizar
        </button>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-hover tabela-cargas">
        <thead>
        <tr>
          <th class="col-saude"></th>
          <th>Rotina</th>
          <th>Modo</th>
          <th>Status</th>
          <th>Última execução</th>
          <th class="text-right">Ações</th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="row in items"
            :key="row.id"
            :class="{ 'linha-quebrada': saudeRotina(row) === 'quebrada' }"
        >
          <td class="col-saude">
            <span
                class="dot-saude"
                :class="`dot-saude--${saudeRotina(row)}`"
                :title="tituloSaudeRotina(row)"
            ></span>
          </td>
          <td>
            <span class="tarefa-nome">{{ row.titulo }}</span>
            <small>#{{ row.id }}<template v-if="row.descricao"> | {{ row.descricao }}</template></small>
          </td>
          <td>
            <span class="tag-modo">{{ row.tipo_execucao | humanTipoExecucao }}</span>
            <small v-if="row.tipo_execucao === 'A'">{{ row.cron | humanCron(crons) }}</small>
          </td>
          <td>
            <span class="label success" v-if="+row.ativo === 1">Ativo</span>
            <span class="label error" v-else>Inativo</span>
          </td>
          <td>
            <div class="ultima-exec-col">
              <template v-if="rotinaLogs[row.id]">
                <span class="ultima-exec" :class="rotinaLogs[row.id].sucesso ? 'ok' : 'falha'">
                  <fa-icon :icon="rotinaLogs[row.id].sucesso ? 'check' : 'times'" />
                  {{ relTime(rotinaLogs[row.id].dthora_fim || rotinaLogs[row.id].dthora_inicio) }}
                </span>
              </template>
              <!-- Enquanto o lote de execuções carrega (ou falhou), não afirmar
                   "Nunca executada": mostra apenas o placeholder. -->
              <span v-else-if="!logsDisponiveis" class="ultima-exec">—</span>
              <span v-else class="ultima-exec nunca">Nunca executada</span>
            </div>
          </td>
          <td class="actions text-right">
            <CButton v-bind:color="tipoButtonRotina(row)" size="sm" v-on:click="openInfo(row)" v-bind:title="row.titulo">
              <fa-icon icon="info-circle"/>
            </CButton>
            <CButton color="success" size="sm" v-on:click="openExecutar(row)" title="Executar">
              <fa-icon icon="play"/>
            </CButton>
            <LogAlteracaoDados tabela="rotina" :chave="row.id">
              <template #trigger="{ open }">
                <CButton
                    color="secondary"
                    variant="outline"
                    size="sm"
                    class="btn-acao-log"
                    title="Log de alterações"
                    @click="open"
                >
                  <fa-icon icon="clipboard-list" />
                </CButton>
              </template>
            </LogAlteracaoDados>
          </td>
        </tr>
        <tr v-if="items.length === 0">
          <td colspan="6" class="vazio">Nenhuma rotina encontrada para este filtro.</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="rodape-paginacao">
      <pagination
          :data="table.paginator"
          :limit="10"
          @pagination-change-page="loadRotinas"
      ></pagination>
    </div>
  </div>
</template>
<script>
import clone from 'just-clone';
import {get, post, put, del} from '@/helpers/apiRequest';
import Executar from './Executar';
import _debounce from 'lodash/debounce';
import InfoRotina from '../InfoRotina.vue';
import LogAlteracaoDados from '@/components/Log/LogAlteracaoDados.vue';
import { relTime } from '@/helpers/cargasSaude';
import { CRONS } from '../constantes';

export default {
  name: 'rotina',
  components: {
    Executar,
    InfoRotina,
    LogAlteracaoDados,
  },
  data() {
    return {
      loading: false,
      currentRotina: {},
      // mapa { [rotina_id]: última execução } carregado em UMA requisição em
      // lote por página (rotina sem log fica fora do mapa = nunca executada).
      rotinaLogs: {},
      rotinaLogsCarregando: false,
      rotinaLogsErro: false,
      items: [],
      descPlural: 'Rotinas',
      descSingular: 'Rotina',
      crons: CRONS,
      termo: '',
      currentPage: 1,
      table: {
        filter: '',
        columns: [
          {label: 'ID', field: 'id', align: 'center', sortable: false},
          {label: 'Título', field: 'titulo', align: 'center', sortable: false},
          {label: 'Ativo', field: 'ativo', align: 'center', sortable: false},
          {label: 'Modo', field: 'tipo_execucao', align: 'center', sortable: false},
          {label: 'Última alteração', field: 'datahora_atualizacao', align: 'center', sortable: false},
          {label: '', field: '', sortable: false},
        ],
        paginator: {},
      },
    };
  },
  computed: {
    // Só afirmamos "Nunca executada" quando o lote respondeu com sucesso;
    // durante o carregamento ou após erro de rede exibimos "—".
    logsDisponiveis() {
      return !this.rotinaLogsCarregando && !this.rotinaLogsErro;
    },
  },
  filters: {
    humanCron(cron, crons) {
      return crons[cron] || cron;
    },
    humanTipoExecucao(tipo_execucao) {
      switch (tipo_execucao) {
        case 'M':
          return 'Manual';
        case 'A':
          return 'Autmático';
      }
      return tipo_execucao;
    },
  },
  methods: {
    relTime(timestamp) {
      return relTime(timestamp);
    },
    // saúde da rotina a partir do status ativo + último log de execução
    saudeRotina(rotina) {
      if (+rotina.ativo !== 1) {
        return 'inativa';
      }
      const log = this.rotinaLogs[rotina.id];
      if (log) {
        return log.sucesso ? 'sucesso' : 'quebrada';
      }
      // Sem o lote carregado não dá para afirmar que nunca executou.
      return this.logsDisponiveis ? 'nunca' : 'indefinida';
    },
    tituloSaudeRotina(rotina) {
      const titulos = {
        sucesso: 'Última execução concluída com sucesso',
        quebrada: 'A última execução falhou',
        inativa: 'Rotina inativa',
        nunca: 'Rotina ativa, mas nunca executada',
      };
      return titulos[this.saudeRotina(rotina)] || '';
    },
    debounceLoadRotinas: _debounce(function () {
      this.loadRotinas(1);
    }, 300),
    loadRotinas(page = 1) {
      this.currentPage = page;
      // Invalida o cache dos logs: Atualizar/paginar sempre reflete o estado atual.
      this.rotinaLogs = {};
      this.rotinaLogsCarregando = true;
      this.rotinaLogsErro = false;

      get(`/admin/rotinas?page=${page}&q=${this.termo}`)
          .then((json) => {
            this.items = json.itens;
            this.table.paginator = json.paginator;
            this.loading = false;
            this.carregarUltimasExecucoes(json.itens);
          })
          .catch((err) => {
            this.loading = false;
            this.rotinaLogsCarregando = false;
            this.rotinaLogsErro = true;
          });
    },
    // Carrega a última execução das rotinas da página em UMA requisição em
    // lote (substitui uma chamada de log-execução por rotina). Rotina ausente
    // no mapa retornado nunca executou; o endpoint aceita no máximo 200 ids.
    carregarUltimasExecucoes(rotinas) {
      const ids = (rotinas || []).map((r) => r.id).filter(Boolean).slice(0, 200);
      if (!ids.length) {
        this.rotinaLogsCarregando = false;
        this.rotinaLogsErro = false;
        return;
      }

      this.rotinaLogsCarregando = true;
      this.rotinaLogsErro = false;
      get(`/admin/rotinas/ultimas-execucoes?ids=${ids.join(',')}`)
        .then((response) => {
          this.rotinaLogs = (response && response.data) || {};
        })
        .catch(() => {
          // erro de rede: mantém o placeholder "—" em vez de mentir "Nunca executada"
          this.rotinaLogs = {};
          this.rotinaLogsErro = true;
        })
        .finally(() => {
          this.rotinaLogsCarregando = false;
        });
    },
    removeRotina(rotina) {
      this.$swal({
        title: 'Confirma Remover?',
        text: 'Essa ação não poderá ser desfeita',
        showCancelButton: true,
        icon: 'warning',
        confirmButtonText: 'Excluir',
        cancelButtonText: 'Cancelar',
      })
          .then((res) => {
            if (res.value) {
              this.loading = true;
              del(`/admin/rotinas/${rotina.id}`)
                  .then((json) => {
                    this.loading = false;
                    this.$swal({
                      title: 'Sucesso!',
                      text: json.message,
                      icon: 'success',
                      confirmButtonText: 'Fechar',
                    })
                        .then(() => {
                          this.loadRotinas();
                        });
                  })
                  .catch((err) => {
                    this.loading = false;
                    this.$swal({
                      title: 'Falha ao remover',
                      text: err.message,
                      icon: 'error',
                    });
                  });
            }
          })
          .catch(() => {
          });
    },
    tipoButtonRotina(rotina) {
      const log = this.rotinaLogs[rotina.id];

      if (log && !log.sucesso) {
        return 'danger';
      }

      if (log && log.sucesso) {
        return 'info';
      }

      return 'secondary';
    },
    openEdit(rotina) {
      this.currentRotina = clone(rotina);
      this.$modal.show('rotinaEdit');
    },
    closeEdit() {
      this.$modal.hide('rotinaEdit');
    },
    openCreate() {
      this.currentRotina = clone({});
      this.$modal.show('rotinaEdit');
    },
    openInfo(rotina) {
      this.currentRotina = rotina;
      this.$modal.show('rotinaInfo');
    },
    closeInfo() {
      this.$modal.hide('rotinaInfo');
    },
    openExecutar(rotina) {
      if (rotina.parametros.length) {
        this.currentRotina = rotina;
        this.$modal.show('rotinaExecutar');
      } else {
        this.$swal({
          title: 'Confirma Executar?',
          text: 'Ao confirmar, esta ação não poderá ser desfeita',
          showCancelButton: true,
          icon: 'warning',
          confirmButtonText: 'Executar',
          cancelButtonText: 'Cancelar',
        })
            .then((res) => {
              if (res.value) {
                this.loading = true;
                this.executarRotina(rotina);
              }
            })
            .catch(() => {
            });
      }
    },
    closeExecutar() {
      this.currentRotina = {};
      this.$modal.hide('rotinaExecutar');
    },
    executarRotina(rotina, hasFile = false, files = []) {
      if (hasFile) {
        let formData = new FormData();

        files.forEach((file) => {
          formData.append(file.name, file.file);
        });

        post(`/admin/rotinas/${rotina.id}/executar`, formData, {isFile: true})
            .then((json) => {
              this.loading = false;
              this.$swal({
                title: 'Sucesso!',
                text: json.message,
                icon: 'success',
                confirmButtonText: 'Fechar',
              })
                  .then(() => {
                    this.closeExecutar();
                    // recarrega a página atual para refletir a nova execução
                    this.loadRotinas(this.currentPage);
                  });
            })
            .catch((err) => {
              this.loading = false;
              this.$swal({
                title: 'Falha ao executar',
                text: err.message,
                icon: 'error',
              });
            });
      } else {
        post(`/admin/rotinas/${rotina.id}/executar`)
            .then((json) => {
              this.loading = false;
              this.$swal({
                title: 'Sucesso!',
                text: json.message,
                icon: 'success',
                confirmButtonText: 'Fechar',
              })
                  .then(() => {
                    this.closeExecutar();
                    // recarrega a página atual para refletir a nova execução
                    this.loadRotinas(this.currentPage);
                  });
            })
            .catch((err) => {
              this.loading = false;
              this.$swal({
                title: 'Falha ao executar',
                text: err.message,
                icon: 'error',
              });
            });
      }
    },
    createRotina() {
    },
    updateRotina() {
    },
  },
  beforeMount() {
    this.loadRotinas();
  },
};
</script>

<style scoped>
/* Tokens VersoTech (escopo da aba de Rotinas).
   Os blocos compartilhados entre as abas vivem no parcial
   src/assets/scss/_cargas.scss, sob a classe raiz .tela-cargas. */
.tabela-cargas {
  margin-top: 14px;
}

.rodape-paginacao {
  display: flex;
  justify-content: center;
  margin-top: 12px;
}

/* Espaçamento entre os botões de ação desta tabela */
.actions ::v-deep .btn {
  margin-left: 5px;
}
</style>
